module.exports = __webpack_public_path__ + "static/media/ic_content_info.b65bdfb4.svg";